/**
 * Bolk global configuration.
 *
 * Override defaults by declaring BolkConfig in <head> BEFORE loading the script:
 *
 *   <script>
 *     BolkConfig = {
 *       lazy: false,
 *       threshold: '30vh',
 *     };
 *   </script>
 *   <script src="https://cdn.../bolklab.min.js"></script>
 */
const defaults = {
  /** Enable lazy loading globally. Per-element override: data-bolk-lazy="false" */
  lazy: true,
  /** IntersectionObserver rootMargin — how far before viewport edge to trigger load */
  threshold: '50vh',
};

export const config = Object.freeze({
  ...defaults,
  ...(typeof window !== 'undefined' && window.BolkConfig ? window.BolkConfig : {}),
});

// IntersectionObserver rootMargin only accepts px and %. Convert vh/vw → px at runtime.
export function toRootMargin(value) {
  return String(value)
    .replace(/(-?\d*\.?\d+)vh/g, (_, n) => `${(parseFloat(n) / 100) * window.innerHeight}px`)
    .replace(/(-?\d*\.?\d+)vw/g, (_, n) => `${(parseFloat(n) / 100) * window.innerWidth}px`);
}
